import FormTextarea from "@mui/joy/Textarea";
import FormLabel from "@mui/joy/FormLabel";
import FormControl from "@mui/joy/FormControl";
import FormHelperText from "@mui/joy/FormHelperText";
import { SxProps } from "@mui/joy/styles/types";
import Tooltip from "@mui/joy/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Typography from "@mui/joy/Typography";

interface Props {
  name: string;
  label?: string;
  infoText?: string;
  helperText?: string;
  register: any;
  defaultValue?: string | number;
  placeholder?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
  minRows?: number;
  maxRows?: number;
  watch?: any;
  sx?: SxProps;
  outerSx?: SxProps;
}

const Textarea = ({
  name,
  label,
  infoText,
  register,
  helperText,
  defaultValue,
  placeholder,
  disabled,
  error,
  autoFocus,
  readOnly,
  maxLength,
  minRows = 10,
  maxRows = 10,
  watch,
  sx,
  outerSx,
  required,
}: Props) => {
  const currentLength = (watch && watch(name)?.length) || 0;
  return (
    <FormControl
      key={name}
      sx={[
        {
          width: "100%",
        },
        ...(Array.isArray(outerSx) ? outerSx : [outerSx]),
      ]}
      size="sm"
      error={!!error}
    >
      {label && (
        <FormLabel
          sx={{
            fontSize: "sm",
            fontWeight: "lg",
            mb: 1,
          }}
          required={required}
        >
          {infoText && (
            <Tooltip
              title={infoText}
              sx={{
                maxWidth: "250px",
              }}
              arrow
              placement="right"
            >
              <InfoOutlinedIcon
                sx={{
                  fontSize: 15,
                  mr: 0.5,
                }}
              />
            </Tooltip>
          )}

          {label}
        </FormLabel>
      )}
      <FormTextarea
        autoFocus={autoFocus}
        placeholder={placeholder}
        error={!!error}
        defaultValue={defaultValue}
        disabled={disabled}
        minRows={minRows}
        maxRows={maxRows}
        readOnly={readOnly}
        slotProps={maxLength ? { textarea: { maxLength } } : undefined}
        {...register(name)}
        sx={[
          ...(Array.isArray(sx) ? sx : [sx]),
          {
            "& textarea": {
              overflow: "auto !important",
              maxHeight: "100%",
            },
          },
        ]}
        endDecorator={
          !label &&
          infoText && (
            <Tooltip
              title={infoText}
              sx={{
                maxWidth: "250px",
              }}
              arrow
              placement="right"
            >
              <InfoOutlinedIcon
                sx={{
                  fontSize: 15,
                }}
              />
            </Tooltip>
          )
        }
      />
      {maxLength && watch ? (
        <Typography
          sx={{
            mt: 0.6,
            fontSize: "xs",
            alignSelf: "flex-end",
            color: currentLength > maxLength ? "danger.500" : "neutral.500",
          }}
        >
          {currentLength}/{maxLength}
        </Typography>
      ) : null}

      {helperText && <Typography sx={{ mt: 0.6, fontSize: "xs", color: "neutral.700" }}>{helperText}</Typography>}

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
export default Textarea;
